import React from "react";
import { useState, useEffect } from "react";
import { Form, Input, Popconfirm, Table, Typography, Button, Modal, Spin } from 'antd';
import {
    SendOutlined, EditOutlined, CheckOutlined, CloseOutlined, DownOutlined, ExclamationCircleOutlined,
    SearchOutlined
} from "@ant-design/icons"
import './TableTimecardFollowup.css';
import { callTimecardsGrid, updateNote, triggerMail } from "../../Repository/TimecardFollowupRepository";
import { SuccessMessage, InfoMessage } from "../../Utils/Utils";

const TimeSheetGrid = ({ statusdata, sendtoParent, tableLoader, setTableLoader, frequency, vms }) => {
    const timecardsData = statusdata;
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [triggerLoader, setTriggerLoader] = useState(false)
    const [openPopup, setOpenPopup] = useState(false);
    const [nodataMsg, setNodataMsg] = useState([])
    const [rowData, setRowData] = useState([]);
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const [openAlert, setOpenAlert] = useState(false)
    const [errorMsg, setErrorMsg] = useState(false)
    const [searchRow, setSearchRow] = useState("")
    const isEditing = (record) => record.Id === editingKey;
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    const edit = (record) => {
        setRowData(record)
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.Id);
    };
    const cancel = () => {
        setEditingKey('');
    };
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
            return (
                String(record.Filenumber)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Client)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.EE)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Email).toLowerCase().includes(value.toLowerCase())
            );
        },
    });
    const columns = [
        {
            title: 'Portal',
            key: 'Portal',
            dataIndex: 'Portal',
            width: 150
        },
        {
            title: 'Client',
            key: 'Client',
            dataIndex: 'Client',
            width: 250,
            ...filterProps(),
        },
        {
            title: 'CSA',
            key: 'CSA',
            dataIndex: 'CSA',
            width: 220
        },
        {
            title: 'EE',
            key: 'EE',
            dataIndex: 'EE',
            width: 220
        },
        {
            title: 'Email',
            key: 'Email',
            dataIndex: 'Email',
            width: 280
        },
        {
            title: 'ECS',
            key: 'Ecs',
            dataIndex: 'Ecs',
            width: 250
        },
        {
            title: 'Work State',
            key: 'ExemptStatus',
            dataIndex: 'ExemptStatus',
            width: 150
        },
        {
            title: 'TC Status',
            key: 'TC_Status',
            dataIndex: 'TC_Status',
            width: 200,
            filters: [
                {
                    text: 'Approved',
                    value: 'Approved',
                },
                {
                    text: 'Invoiced',
                    value: 'Invoiced',
                },
                {
                    text: 'Pending Approval',
                    value: 'Pending Approval',
                },
                {
                    text: 'Missing',
                    value: 'Missing',
                },
                {
                    text: 'Draft',
                    value: 'Draft',
                },
                {
                    text: 'Submitted',
                    value: 'Submitted',
                },
                {
                    text: 'Yes',
                    value: 'Yes',
                }
            ],
            onFilter: (value, record) => {
                if (value === 'Submitted') {
                    return record.TC_Status && record.TC_Status.startsWith('Submitted');
                } else if (value === 'Invoiced') {
                    return record.TC_Status && record.TC_Status.startsWith('Invoiced');
                } else if (value === 'Pending Approval') {
                    return record.TC_Status && record.TC_Status.startsWith('Pending Approval');
                } else if (value === 'Missing') {
                    return record.TC_Status && record.TC_Status.startsWith('Missing');
                }
                else if (value === 'Draft') {
                    return record.TC_Status && record.TC_Status.startsWith('Draft');
                } else if (value === 'Approved') {
                    return record.TC_Status && record.TC_Status.startsWith('Approved');
                } else if (value === 'Yes') {
                    return record.TC_Status && record.TC_Status.startsWith('Yes');
                }
                return false;
            },
            filterIcon: (filtered) => (
                <DownOutlined style={{ color: filtered ? "#003A8C" : "#003A8C" }} />),
        },
        {
            title: 'Category',
            key: 'Category',
            dataIndex: 'Category',
            width: 110
        },
        {
            title: 'Frequency',
            key: 'Frequency',
            dataIndex: 'Frequency',
            width: 120
        },
        {
            title: 'ST',
            key: 'RT',
            dataIndex: 'RT',
            width: 100
        },
        {
            title: 'OT',
            key: 'OT',
            dataIndex: 'OT',
            width: 100
        },
        {
            title: 'DT',
            key: 'DT',
            dataIndex: 'DT',
            width: 100
        },
        {
            title: 'Other',
            key: 'OTHER',
            dataIndex: 'OTHER',
            width: 100
        },
        {
            title: 'Week ending',
            key: 'Week_Ending',
            dataIndex: 'Week_Ending',
            width: 190
        },
        {
            title: 'Timecard Coordinator',
            key: 'Timecard_Coordinator',
            dataIndex: 'Timecard_Coordinator',
            width: 190
        },
        // {
        //     title: 'CS Director',
        //     key: 'CS_Director',
        //     dataIndex: 'CS_Director',
        //     width: 150
        // },
        {
            title: 'CSM',
            key: 'CSM',
            dataIndex: 'CSM',
            width: 150
        },

        {
            title: 'Notes',
            key: 'Note',
            dataIndex: 'Note',
            editable: true,
            width: 400,
            // className:'note-column'
        },
        {
            title: 'Action',
            dataIndex: 'action',
            fixed: 'right',
            width: 100,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Popconfirm title="Sure to save?" onConfirm={() => save(record)}>
                            <Typography.Link
                                style={{
                                    marginRight: 8,
                                }}
                            >
                                <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
                            </Typography.Link>
                        </Popconfirm>
                        <Typography.Link onClick={() => cancel()}>
                            <CloseOutlined style={{ color: "red" }} />
                        </Typography.Link>

                    </span>
                ) : (

                    <Typography.Link onClick={() => edit(record)}>
                        <div>
                            <EditOutlined style={{ fontSize: 18, color: '#003A8C' }} />
                        </div>
                    </Typography.Link>
                );
            },
        },
    ];
    const compareObjects = (obj1, obj2) => {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) {
            return false;
        }
        for (const key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }
        return true;
    };

    const compareLists = (rowData, currentRowData) => {
        if (typeof rowData !== 'object' || typeof currentRowData !== 'object') {
            return false;
        }
        const result = compareObjects(rowData, currentRowData);
        return result;
    };
    const save = async (record) => {
        try {
            const currentRowData = await form.getFieldValue();
            const comparision = compareLists(rowData, currentRowData);
            if (comparision === false) {
                const res = await updateNote(currentRowData);
                if (res !== null) {
                    const response = await callTimecardsGrid(frequency, vms);
                    if (response != null && response.length > 0) {
                        sendtoParent(response)
                        SuccessMessage(res)
                    }
                }
                setEditingKey("");
            }
            else {
                InfoMessage("No changes made. Edit and try again.")
            }
        }
        catch {

        }
    }
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const sendTrigger = async () => {
        if (selectedRowKeys.length > 0) {
            setTriggerLoader(true)
            const res = await triggerMail(selectedRowKeys);
            if (res !== null && res === 'Email sent successfully !!') {
                SuccessMessage(res)
                setSelectedRowKeys([])
            }
            else if (res !== null) {
                setNodataMsg(res);
                setOpenPopup(true)
            }
        }
        setOpenAlert(false)
        setTriggerLoader(false)
    }
    const callConfirmationModal = () => {
        setErrorMsg(false)
        if (selectedRowKeys.length === 0) {
            setErrorMsg(true)
        }
        else {
            setOpenAlert(true)
        }
    }
    return (
        <>
            <div className="ts-search-row">
                <Input
                    placeholder="Search Client \ Email \ File Number \ EE"
                    className="ts-searchrow"
                    style={{ borderColor: "#002766", color: "#F4F9FF" }}
                    onChange={(e) => setSearchRow(e.target.value)}
                    allowClear
                    suffix={
                        <SearchOutlined
                            style={{ color: "#002766", justifyContent: "space-between" }}
                        />
                    }
                />
            </div>
            <div className="timesheet-table-div">
                <Modal open={openPopup} footer={false} onCancel={() => setOpenPopup(false)}>{nodataMsg}</Modal>
                <div className={timecardsData.length > 0 ? "timesheet-table-class" : "timesheet-empty-table"}>
                    {
                        tableLoader ?
                            <Spin tip="Loading...">
                                <Form form={form} component={false}>
                                    <Table
                                        className="timesheet-table"
                                        rowClassName="editable-row"
                                        columns={mergedColumns}
                                        dataSource={timecardsData.map(item => ({ ...item, key: item.Id }))}
                                        components={{ body: { cell: EditableCell, }, }}
                                        bordered
                                        rowSelection={rowSelection}
                                        scroll={{ x: "max-content" }}
                                    // pagination
                                    /> </Form> </Spin> :
                            timecardsData.length > 0 ? < Form form={form} component={false} >
                                <Table
                                    className="timesheet-table"
                                    rowClassName="editable-row"
                                    columns={mergedColumns}
                                    dataSource={timecardsData.map(item => ({ ...item, key: item }))}
                                    components={{ body: { cell: EditableCell, }, }}
                                    bordered
                                    rowSelection={rowSelection}
                                    scroll={{ x: 1500, y: 400 }}
                                />
                            </Form> : < Form form={form} component={false} >
                                <Table
                                    className="timesheet-table"
                                    rowClassName="editable-row"
                                    columns={mergedColumns}
                                    dataSource={timecardsData.map(item => ({ ...item, key: item }))}
                                    components={{ body: { cell: EditableCell, }, }}
                                    bordered
                                    rowSelection={rowSelection}
                                    scroll={{ x: 400, y: 400 }}
                                />
                            </Form>
                    }
                </div>

                <div style={{ width: "97%", display: "flex", justifyContent: "flex-end" }}>
                    <Button type="submit" className="send-trigger-button" onClick={callConfirmationModal} >
                        Trigger Mail<SendOutlined style={{ transform: "rotate(310deg)" }} /></Button>
                    <Modal
                        open={openAlert}
                        footer={false}
                        onOk={() => setOpenAlert(false)}
                        onCancel={() => setOpenAlert(false)}
                        style={{ maxHeight: '500px' }}
                    >
                        <div>
                            <div className="text-icon-class">
                                <div><ExclamationCircleOutlined style={{ fontSize: 20, color: "rgba(0, 39, 102, 1)", marginRight: 15, marginBottom: "25px" }} /></div>
                                <div style={{ fontWeight: 400, fontSize: 16, marginTop: -6, color: "rgba(0, 39, 102, 1)" }}>Mails will be send to the clients whose ST{`>`}0 and TC Status is missing</div>
                            </div>
                            <div className="ts-buttons-class">
                                <div className="modal-buttons">
                                    <Button className="ts-cancel-button" onClick={() => setOpenAlert(false)}>Cancel</Button>
                                    <Button className="ts-yes-button" onClick={sendTrigger} loading={triggerLoader}>Ok</Button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="mail-error">
                    {errorMsg && <div style={{ color: "#FF0000" }}>*Please select clients</div>}
                </div>
            </div >

        </>
    )
}
export default TimeSheetGrid;